import {type PartialOptions, UI} from "../../../../../stem-core/ui/UIBase";
import {Link} from "../../../../../stem-core/ui/primitives/Link";
import {LabeledToggle} from "../../../components/LabeledToggle.jsx";
import {Toast} from "../../../../ui/Toast.jsx";
import {Messages} from "../../../../Messages.js";
import {userService} from "../../../../../client/connection/services/UserService.js";
import {apiUpdateUserMerchantPreferences} from "../../../../../client/state/merchant/MerchantUserStore.js";
import type {Merchant} from "../../../../../client/state/MerchantStore";


interface AutopaySettingOptions {
    merchant?: Merchant;
}

export class AutopaySetting extends UI.Element<AutopaySettingOptions> {
    getDefaultOptions(): PartialOptions<AutopaySetting> {
        return {
            merchant: null,
        };
    }

    getSettingLabel() {
        const {merchant} = this.options;

        return <Link href={merchant.getUrl()} newTab>
            {merchant}
        </Link>;
    }

    async handleSettingToggle() {
        try {
            await apiUpdateUserMerchantPreferences({
                merchantId: this.options.merchant.id,
                autoPayEnabled: !userService.isAutoPayEnabledForMerchant(this.options.merchant),
            });
            Toast.show(Messages.changesSaved);
        } catch (error) {
            Toast.showError(error, Messages.errorWhileSaving);
        }
    }

    render() {
        const {merchant} = this.options;

        return <LabeledToggle
            label={this.getSettingLabel()}
            initialValue={userService.isAutoPayEnabledForMerchant(merchant)}
            onChange={() => this.handleSettingToggle()}
        />;
    }
}
